@if (isVisible$ | async) {
  <div class="persona-verification-banner" role="status">
    <i class="material-icons persona-verification-banner__icon" aria-hidden="true">warning</i>
    <span class="persona-verification-banner__message">
      Identity Verification is required on your account.
      <a class="persona-verification-banner__link" [href]="link">Go to Tester Profile &gt; Identity</a> to get started.
    </span>
  </div>
}
